var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"","visible":_vm.visible,"width":"50%","append-to-body":"","show-close":true,"top":"10vh"},on:{"update:visible":function($event){_vm.visible=$event}}},[_c('div',{staticClass:"main__container"},[_c('div',{staticClass:"wrapper2 ml-6"},[_c('div',{staticClass:"content"},[_vm._t("default")],2)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }